<div class="col-lg-12 col-md-12 col-sm-12 card" [ngClass]="{'dark-mode': darkMode===true}">
  <div
    *ngIf="currentUser.role.name === 'root' || currentUser.role.name === 'customer' || currentUser.role.name === 'client'"
    class="card-header border-header">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h3 class="d-inline-block mb-0" translate>user.selectNewPreset</h3>
      <div class="config-actions">
        <button *ngIf="currentUser.role.name === 'root'" class="config-btn" (click)="openPremiumTargetsPopup()">
          <i class="fa fa-star"></i> Premium
        </button>
        <button *ngIf="currentUser.role.name === 'root'" class="config-btn" (click)="navigateToVideoConfigurator()">
          <i class="fa fa-video-camera"></i> Video
        </button>
        <button *ngIf="currentUser.role.name === 'root' && canUseScalingConfigurator" class="config-btn" (click)="navigateToScalingConfigurator()">
          <i class="fa fa-expand"></i> Scaling
        </button>
        <button *ngIf="canUseConfigurator" class="config-btn" (click)="navigateToConfigurator()">
          <i class="fa fa-image"></i> Fillable
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="currentUser.role.name === 'root' || currentUser.role.name === 'customer' || currentUser.role.name === 'client'"
    class="form-group">
    <div #searchContainer [ngClass]="{'active' : showPresets}" class="div select-bg search-container"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openPresets()" name="selectedPreset" [(ngModel)]="selectedPreset">
      <div class="prikaz" *ngIf="showPresets">
        <div class="backdrop" (click)="openPresets()"></div>
        <div style="z-index: 100; overflow-y: auto;">
          <div class="divider"></div>
          <input type="text" class="search-marke" (input)="applyPresetFilter()"
            [attr.placeholder]="'user.search' | translate" name="searchPresetParam" name="searchPresetParam"
            [(ngModel)]="searchPresetParam">
          <ul style="margin-bottom: 12px;">
            <li *ngFor="let preset of presetsSearch" (click)="showPresets=!showPresets; addPreset(preset.id)">
              {{ preset.name }}
              <ng-container>
                <div class="position-relative">
                  <div class="bg-all-files" [style.background-image]="'url(assets/img/logo.png)'"></div>
                </div>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <ul>
    <li *ngFor="let preset of selectedPresets">
      {{preset.name}}
      <button class="btn button-x" (click)="removePresetItem(preset.id)">x</button>
    </li>
  </ul>
  <hr>
  <div class="card-header border-header">
    <h3 translate>{{title}}</h3>
  </div>
  <div class="row">
    <div *ngIf="userPresets && !userPresets.length" style="min-height: 60px;">
      <p class="no-data-message" translate>{{noDataMsg}}</p>
    </div>
    <div class="col-lg-3 col-sm-6" *ngFor="let preset of userPresets | slice: (presetPage-1) * presetPerPage : (presetPage-1) * presetPerPage + presetPerPage">
      <div class="root-application-bg-container ">
        <div class="root-application-image-delete" (click)="showDialogDeletePreset(dialogDeletePreset, preset)">
        </div>
        <div *ngIf="currentUser.role.name === 'root' && router.url.includes('/root/users')" class="root-application-image-delete settings-icon" (click)="showDialogEditPreset(dialogScaleFactor, preset)"></div>
        <div class="widget-user-header bg-info-active">
          <div class="row container-bg">
            <ng-container>
              <div class="position-relative">
                <div class="bg-files" [style.background-image]="'url(assets/img/logo.png)'"></div>
              </div>
            </ng-container>
          </div>
          <h5 class="widget-user-username">{{preset?.name}}</h5>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix w-100"></div>
  <ngb-pagination *ngIf="userPresets && userPresets.length>8" [collectionSize]="userPresets.length"
    [(pageSize)]="presetPerPage" [(page)]="presetPage" [maxSize]="5" [rotate]="true"
    (pageChange)="jumpToPresetsPage($event)"></ngb-pagination>
</div>

<!-- delete preset -->
<ng-template #dialogDeletePreset let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>user.deletePreset</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <p translate>{{ 'user.deletePresetText' | translate :{preset: presetToDelete.name} }}</p>
      <!-- <div class="image-delete-thumb" [style.background-image]="'url(' + fileToDelete?.fileInfo.path + ')'"></div> -->
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deletePreset()" translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

<!-- edit scale factor -->
<ng-template #dialogScaleFactor let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>Scale configuration</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <form #presetForm="ngForm" (ngSubmit)="editPreset(presetForm)" name="scaleFactor">
        <div class="form-group pb-3">
          <input #scaleFactor="ngModel" [ngModel]="presetToEdit?.userPreset.scaleConfiguration?.scale_factor" name="scale_factor" type="number" class="form-control input-underline" placeholder="Scale Factor" required>
        </div>
        <div class="row col-12">
          <button type="submit" class="form-control btn btn-block btn-success"
                translate>global.edit</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>